import { API_CLIENTS_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  ApiClient,
  Error,
  GetApiClientResponseItem
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (value: GetApiClientResponseItem) => void
  onError?: (error: Error) => void
  children?: () => ReactElement
  params: ApiClient
}

const CreateApiClientsServiceRequest = ({
  onSuccess,
  onError,
  children,
  params
}: Props) => {
  const url = `${API_CLIENTS_SERVICE}/api_clients`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateApiClientsServiceRequest
